import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

import { Loading } from '@woovi/ui';

const PluginSwipeableDialogContentLoading = (): ReactNode => {
  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      sx={{ height: '100%', my: 'auto' }}
    >
      <Loading />
    </Stack>
  );
};

export default PluginSwipeableDialogContentLoading;
